const e = (e2, t = 60) => (e2 == null ? void 0 : e2.length) > t ? `${e2.slice(0, t)}...` : e2;
export {
  e as cutTitle
};
//# sourceMappingURL=cutTitle.js.map
